<template>
  <transition name="modal-fade">
    <div v-if="show" class="modal-overlay" @click="$emit('close')">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="$emit('close')">✕</button>
        
        <div class="modal-header">
          <h3 class="modal-title">🎉 恭喜完成所有题目！</h3>
          <p class="modal-description">更多精彩内容，尽在小程序</p>
        </div>
        
        <div class="qr-code-section">
          <div class="qr-code-placeholder">
            <div class="qr-icon">📱</div>
            <p class="qr-text">小程序二维码</p>
          </div>
          <div class="scan-instruction">
            <p class="instruction-text">微信扫一扫</p>
            <p class="instruction-subtext">解锁更多好题</p>
          </div>
        </div>
        
        <div class="features">
          <div class="feature-item">
            <span class="feature-icon">🎯</span>
            <span class="feature-text">海量题库</span>
          </div>
          <div class="feature-item">
            <span class="feature-icon">⭐</span>
            <span class="feature-text">收藏功能</span>
          </div>
          <div class="feature-item">
            <span class="feature-icon">✨</span>
            <span class="feature-text">体验舒适</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MiniProgramModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style src="@/styles/MiniProgramModal.css"></style>
